import { defineComponent, onMounted, h } from "vue";
import { V as VaIcon } from "../va-icon/index-7fefcddb.mjs";
const _sfc_main = defineComponent({
  name: "VaFallback",
  props: {
    fallbackSrc: {
      type: String
    },
    fallbackText: {
      type: String
    },
    fallbackIcon: {
      type: String
    },
    fallbackRender: {
      type: Function
    }
  },
  components: { VaIcon },
  emits: ["fallback"],
  setup(props, { emit }) {
    onMounted(() => {
      emit("fallback");
    });
    if (props.fallbackIcon) {
      return () => h(VaIcon, {
        name: props.fallbackIcon
      });
    }
    if (props.fallbackSrc) {
      return () => h("img", {
        src: props.fallbackSrc
      });
    }
    if (props.fallbackRender) {
      return () => {
        var _a;
        return h((_a = props.fallbackRender) == null ? void 0 : _a.call(props));
      };
    }
    return () => h("span", props.fallbackText);
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaFallback.vue_vue_type_script_lang-00a32d73.mjs.map
